namespace $ {
	export function $shm_projects_task_get( project_id: string, id: string ) {
		return $shm_projects_tasks_list( project_id ).find( task => task.id === id ) ?? null
	}
}
